import { render, staticRenderFns } from "./CalidadImpresionTab.vue?vue&type=template&id=3111f1a2&"
import script from "./CalidadImpresionTab.vue?vue&type=script&lang=js&"
export * from "./CalidadImpresionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports